// @flow

const Goals2050Agenda2030Map = {
  "31810": [
    // yhdenvertaisuus
    31822,
    31828,
    31819,
    31820,
    31821,
    31823,
    31826,
    31834,
    31835
  ],
  "31809": [
    // vaikuttavien kansalaisten yhteiskunta
    31834,
    31822,
    31828,
    31835
  ],
  "31808": [
    // työtä kestävästi
    31826,
    31822,
    31827,
    31830,
    31834,
    31835
  ],
  "31807": [
    // resurssiviisas talous
    31826,
    31827,
    31820,
    31824,
    31825,
    31830,
    31833,
    31835
  ],
  "31806": [
    // luontoa kunnioittava pääsetöksenteko
    31833,
    31834,
    31821,
    31824,
    31830,
    31832,
    31835
  ],
  "31805": [
    // kestävät yhteiskunnat
    31821,
    31829,
    31828,
    31831,
    31834,
    31835
  ],
  "31804": [
    // kestävät elämäntavat
    31830,
    31822,
    31826,
    31827,
    31835
  ],
  "31803": [
    // hiilineutraali yhteiskunta
    31825,
    31831,
    31820,
    31827,
    31833,
    31835
  ],
  "747968": [
    // Hyvinvointia edistävä talous ja työ sekä kestävä kulutus
    31826, // 8 työtä ja talouskasvua
    31827, // 9 kestävää teollisuutta
    31830, // 12 kuluttaminen

  ],
  "747970": [
    // Sivistys, osaaminen ja kestävät elämäntavat
    31822, // 4 hyvä koulutus
    31823, // 5 sukupuolten tasa-arvo
    31828, // 10 eriarvoisuuden vähentäminen
    31831, // 13 ilmastotekoja
  ],
  "747972": [
    // Hyvinvointi, terveys ja yhteiskunnallinen osallisuus
    31819, // 1 ei köyhyyttä
    31821, // 3 terveyttä ja hyvinvointia
    31823, // 5 sukupuolten tasa-arvo
    31828, // 10 eriarvoisuuden vähentäminen
    31834, // 16 rauha ja hallinto
  ],
  "747974": [
    // Hyvinvointia edistävä ruokajärjestelmä
    31820, // 2 ei nälkää
    31824, // 6 puhdas vesi
    31830, // 12 kuluttaminen
    31831, // 13 ilmastotekoja
    31832, // 14 vedenalainen
    31833, // 15 maanpäällinen
  ],
  "747976": [
    // Monimuotoisuutta ja hiilineutraaliutta vahvistava metsien, vesien ja maan käyttö
    31820, // 2 ei nälkää
    31824, // 6 puhdas vesi
    31829, // 11 kestävät kaupungit
    31833, // 15 maanpäällinen
  ],
  "747978": [
    // Kestävä energiajärjestelmä
    31825, // 7 puhdasta energiaa
    31827, // 9 kestävää teollisuutta
    31830, // 12 kuluttaminen
    31831, // 13 ilmastotekoja
  ],
  hundredTodos: [
    // 100 fiksua tekoa
    31820,
    31824,
    31825,
    31830,
    31831,
    31835
  ]
};

export default Goals2050Agenda2030Map;

//
// map.put("Yhdenvertaisuus", ag1);
// map.put("Vaikuttavien kansalaisten yhteiskunta", ag2);
// map.put("Työtä kestävästi", ag3);
// map.put("Kestävät yhdyskunnat", ag4);
// map.put("Hiilineutraali yhteiskunta", ag5);
// map.put("Resursiviisas talous", ag6);
// map.put("Kestävät elämäntavat", ag7);
// map.put("Luontoa kunnioittava päätöksenteko", ag8);
//
// 	List<Long> ag1 = new ArrayList<Long>(
// 			Arrays.asList(
// 				31822l,
// 				31828l,
// 				31819l,
// 				31820l,
// 				31821l,
// 				31823l,
// 				31826l,
// 				31834l,
// 				31835l));
//
// 	List<Long> ag2 = new ArrayList<Long>(
// 			Arrays.asList(
// 				31834l,
// 				31822l,
// 				31828l,
// 				31835l));
// 	List<Long> ag3 = new ArrayList<Long>(
// 			Arrays.asList(
// 				31826l,
// 				31822l,
// 				31827l,
// 				31830l,
// 				31834l,
// 				31835l));
// 	List<Long> ag4 = new ArrayList<Long>(
// 			Arrays.asList(
// 				31821l,
// 				31829l,
// 				31828l,
// 				31831l,
// 				31834l,
// 				31835l));
// 	List<Long> ag5 = new ArrayList<Long>(
// 			Arrays.asList(
// 				31825l,
// 				31831l,
// 				31820l,
// 				31827l,
// 				31833l,
// 				31835l));
// 	List<Long> ag6 = new ArrayList<Long>(
// 			Arrays.asList(
// 				31826l,
// 				31827l,
// 				31820l,
// 				31824l,
// 				31825l,
// 				31830l,
// 				31833l,
// 				31835l));
// 	List<Long> ag7 = new ArrayList<Long>(
// 			Arrays.asList(
// 				31830l,
// 				31822l,
// 				31826l,
// 				31827l,
// 				31835l));
// 	List<Long> ag8 = new ArrayList<Long>(
// 			Arrays.asList(
// 				31833l,
// 				31834l,
// 				31821l,
// 				31824l,
// 				31830l,
// 				31832l,
// 				31835l));
//
// }



// WEBPACK FOOTER //
// ./src/utils/Goals2050Agenda2030Map.js